export default __webpack_public_path__ + "static/media/firebase.6155eef8.png";